type MediaType = "sm" | "md" | "lg" | "xl";

const medias = { sm: 600, md: 900, lg: 1200, xl: 1400 };

export const mqMinScreen = (type: MediaType) => {
  return `@media (min-width: ${medias[type]}px)`;
};
